import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { SystemResource, SystemResources } from "./../../../models/system-resources";

export function useFetchAllSystemResources() {
  const systemResources:SystemResource[] = useSelector(
    (rootState: RootState) => rootState.systemResources.systemResourcesPEV.value.systemResources??[]
  );

  return new SystemResources(systemResources);
}
